class ProductVariantAtc {
  constructor () {
    this.setupListeners()
  }

  setupListeners () {
    document.addEventListener('click', this.handleDocumentClick.bind(this))
  }

  async handleDocumentClick (e) {
    const button = e.target?.closest('[data-product-variant-atc-el="button"]')
    if (!button) return

    const variantId = button.getAttribute('data-variant-id')
    if (variantId) {
      await this.addVariantToCart(variantId)
    }
  }

  async addVariantToCart (variantId) {
    try {
      window.BAO.Cart.addItem({
        id: parseInt(variantId),
        quantity: 1,
      })
    } catch (error) {
      console.error('Error adding variant:', error)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BAO.productVariantAtc = new ProductVariantAtc()
})
